<template>
  <!--
    MazInput con type="text" a propósito: con type="number", maz-ui 2.4.7 convierte el vacío
    en 0 y trunca con parseInt antes de que el padre reciba nada (ticket P3-I275), así que no
    se puede corregir desde fuera. En texto no coerciona, y la conversión la hace aNumeroOpcional.
    inputmode="decimal" le da al móvil el teclado numérico; MazInput pasa $attrs al <input>.
  -->
  <MazInput
    :value="texto"
    type="text"
    inputmode="decimal"
    :error="!valido"
    v-bind="$attrs"
    @input="alCambiar"
  />
</template>

<script>
import { aNumeroOpcional, aTextoOpcional } from "@/util/numeros";

/**
 * Campo numérico que puede quedar vacío, y vacío es null —no 0—. Úsese cuando «sin valor»
 * significa algo distinto de cero, como los topes de horas extras («sin límite»).
 *
 * v-model entra y sale como número o null. Lo que no se puede leer como número no se emite:
 * el campo se marca con error y el modelo conserva el último valor válido, para no guardar en
 * silencio un «sin límite» que nadie capturó.
 */
export default {
  name: "NumeroOpcional",
  inheritAttrs: false,
  props: {
    value: { type: Number, default: null },
    // Sólo enteros, para campos que el back declara int (p. ej. TopeDiasConHE).
    enteros: { type: Boolean, default: false },
  },
  data() {
    return { texto: aTextoOpcional(this.value), valido: true };
  },
  watch: {
    // Sólo se reescribe el texto cuando el valor cambia desde fuera (al cargar otra política).
    // Si el cambio viene de lo que el usuario está tecleando, el texto ya dice ese valor y no se
    // le pisa. Un texto inválido siempre se reemplaza: si no, un «abc» parsea a null y sobrevive
    // al cargar una política cuyo tope también es null.
    value(nuevo) {
      const actual = aNumeroOpcional(this.texto, { enteros: this.enteros });
      if (!actual.valido || actual.valor !== nuevo) {
        this.texto = aTextoOpcional(nuevo);
        this.valido = true;
      }
    },
  },
  methods: {
    alCambiar(texto) {
      this.texto = texto;
      const r = aNumeroOpcional(texto, { enteros: this.enteros });
      this.valido = r.valido;
      if (r.valido) this.$emit("input", r.valor);
    },
  },
};
</script>
